<div class="step-box align-center">
	<div class="row">
		<div class="col-md-12">
			<span jhiTranslate="multi-trait-query.panel.introduction.comment"></span>
		</div>
	</div>
	<br/>
	<div class="row">
		<div class="col-md-12">
			<button (click)="nextStep()" class="btn btn-primary ms-2" jhiTranslate="next">Next</button>
		</div>
	</div>
</div>
